import React from "react";

import { useLinkPayCookies } from "../../../common/hooks/useLinkPayCookies";
import Condition from "../../../components/Conditional/Condition";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContext";
import { isPaymentMethodEnabled, PAYMENT_METHOD } from "../../../contexts/ConfigContext/paymentMethods";
import AdyenCheckoutForm from "../AdyenCheckoutForm";
import LinkpayCheckoutForm from "../LinkpayCheckoutForm";

/**
 * The v2 flow, exactly as it shipped: the FairPrice app injects the LinkPay cookies and the
 * customer pays with their default card. Rendered when the venue's linkpay_v3_enabled config
 * is off. The decision below is carried verbatim from the pre-v3 payment page; the forms it
 * renders are the original v2 files, untouched.
 */
const LinkPayV2CheckoutForm = () => {
	const { hasPaymentMethod, isAuthenticated } = useLinkPayCookies();
	// The card fallback also obeys the venue's payment_methods list (FOOD-3321).
	const { state: paymentMethods } = useConfigContext((state) => state.paymentMethods);

	// Show Linkpay only if user is authenticated AND has default card
	// Otherwise show Adyen for card payment
	const shouldShowLinkpay = isAuthenticated && hasPaymentMethod;

	return (
		<>
			<Condition
				check={!shouldShowLinkpay && isPaymentMethodEnabled(paymentMethods, PAYMENT_METHOD.ADYEN)}
			>
				<AdyenCheckoutForm />
			</Condition>
			<Condition check={shouldShowLinkpay}>
				<LinkpayCheckoutForm />
			</Condition>
		</>
	);
};

export default LinkPayV2CheckoutForm;
